module.exports = __webpack_public_path__ + "public/images/netw-how-to-use.081ae5f61c60022bdea1f66c3ceb92ab.png";